import { post } from "@/shared/api/api-client";
import { injectable } from "inversify";
import { ISearchBatchesRequest } from "../ts/index.types";

@injectable()
export class SearchService {
    getSearchBatches(params: ISearchBatchesRequest) {
        return post(`${PUBLIC_API_URL}/search`, { ...params });
    }
}